module.exports = __webpack_public_path__ + "static/media/pictureWithCaption.4b5e9c52.png";